import { render, staticRenderFns } from "./IntraoralSaveDialog.vue?vue&type=template&id=9161fdd0&scoped=true&"
import script from "./IntraoralSaveDialog.vue?vue&type=script&lang=js&"
export * from "./IntraoralSaveDialog.vue?vue&type=script&lang=js&"
import style0 from "./IntraoralSaveDialog.vue?vue&type=style&index=0&id=9161fdd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9161fdd0",
  null
  
)

export default component.exports